import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { all, fork } from "redux-saga/effects";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Use this for localStorage

import loginRootSaga from "./auth";
import loginReducer from "../reducers/auth";
import coursesReducer from "../reducers/courses";
import coursesRootSaga from "./courses";
import homeReducer from "../reducers/home";
import homeRootSaga from "./home";

function* rootSaga() {
  yield all([fork(loginRootSaga), fork(coursesRootSaga), fork(homeRootSaga)]);
}

// Create the saga middleware
const sagaMiddleware = createSagaMiddleware();

// Persist configurations
const authPersistConfig = {
  key: "auth",
  storage: storage, // Use localStorage
  whitelist: [
    "token",
    "user",
    "selectedSideMenu",
    "topBarList",
    "isInstructor",
    "chatGroupId",
    "chatGroupTitle",
    "userName",
    'profile'
  ],
};

const homePersistConfig = {
  key: "home",
  storage: storage, // Use localStorage
  whitelist: [
    "folders",
    "total_courses",
    "total_students",
    "credit_hours",
    "chatList",
    "userList",
    "courses",
    "allCourses",
    "news",
    "downloadedNews",
    "enrollReqList",
    "courseContent",
    "new_courses",
    "awaiting_courses",
    "mailList",
    "awaiting_courses_count",
    "my_courses_count",
    "new_courses_count",
    "user_count",
    "userList",
    'courseUsers',
  ],
};

// Combine reducers
const combinedReducers = combineReducers({
  auth: persistReducer(authPersistConfig, loginReducer),
  home: persistReducer(homePersistConfig, homeReducer),
  courses: coursesReducer,
  //   cart: persistReducer(cartPersistConfig, cartReducer),
});

// Redux DevTools configuration
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Create store with middleware
const store = createStore(
  combinedReducers,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);

// Persist the store
const persistor = persistStore(store);

// Run the saga
sagaMiddleware.run(rootSaga);

export { store, persistor };
